export default __webpack_public_path__ + "static/media/axa.3afda5ec.png";